import { useEffect } from 'react';

interface UseHistoryPopstateProps {
    closeModal: () => void;
    isModalOpen: boolean;
}

type State = {
    popupOpen?: boolean;
};

export const popStateCloseModal = (): void => {
    window.history.replaceState({ ...window.history.state, popupOpen: false }, '');
};

export const popStateGoBack = (): void => {
    const state = window.history.state as State;
    if (state?.popupOpen === true) {
        window?.history?.back();
    }
};

export const useHistoryPopstate = ({ closeModal, isModalOpen }: UseHistoryPopstateProps): void => {
    useEffect(() => {
        // Listen for the popstate event to handle back button clicks
        const handlePopState = (): void => {
            popStateCloseModal();
            closeModal();
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [closeModal]);

    useEffect(() => {
        if (!isModalOpen) {
            popStateGoBack();
        }
    }, [isModalOpen]);
};
